import { render, staticRenderFns } from "./appleForLeaveApproval.vue?vue&type=template&id=4a2185d7&scoped=true&"
import script from "./appleForLeaveApproval.vue?vue&type=script&lang=js&"
export * from "./appleForLeaveApproval.vue?vue&type=script&lang=js&"
import style0 from "./appleForLeaveApproval.vue?vue&type=style&index=0&id=4a2185d7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2185d7",
  null
  
)

export default component.exports